module.exports = __webpack_public_path__ + "img/sidenav-item-settings.2bb2c10b.svg";